import NewScheduleFlow from "../../ScheduleNew/NewScheduleFlow/NewScheduleFlow";

const ScheduleMenuFlow = () => {
  return <NewScheduleFlow />;
};

export default ScheduleMenuFlow;
